import { getAxiosInstance } from "./axiosInstance";

const createToken = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/esimdata/token/create/",
    data
  );
};

const getTokenList = (showAll = false) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/esimdata/token/list/",
    {
      show_all: showAll,
    }
  );
};

const revokeToken = (id) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/esimdata/token/revoke/",
    {
      id,
    }
  );
};

const TokenService = {
  createToken,
  getTokenList,
  revokeToken,
};

export default TokenService;